import React from 'react';
import './TopNavButtons.css';

const TopNavButtons = (props: any) => {
	const onHowToPlayKeyboard = (e:any)=> {
		if(e.keyCode == 32 || e.keyCode == 13){ //32 - spacebar, 36 - enter
			props.howToPlay.onClick();
		}
	};
	
	const onDisplayLearningReviewKeyboard = (e:any)=> {
		if(e.keyCode == 32 || e.keyCode == 13){ //32 - spacebar, 36 - enter
			props.displayLearningReview();
		}
	};
	
	return (
		<div className="ui-inner-container top-nav modal-disable-select">
			<div className="how-to-play block" 
				onClick={props.howToPlay.onClick} 
				tabIndex={0}
				onKeyDown={onHowToPlayKeyboard}>
				<div className="how-to-play-holder-holder holder">
					<img className="icon" src={'./assets/img/tutorial_icon.png'}/>
					<p className="text">HOW TO PLAY</p>
				</div>
			</div>
			<div className="learning-review block">
				<div className="learning-review-holder holder" 
					onClick={props.displayLearningReview}
					tabIndex={0}
					onKeyDown={onDisplayLearningReviewKeyboard}>
					<img className="icon" src={'./assets/img/learn_icon.png'} />
					<p className="text">LEARNING REVIEW</p>
				</div>
			</div>
		</div>
	);
};

export default TopNavButtons;
